<div class="form-control form-select filterOffcanvas__inputlabel">
    <div>
        <button class="drop-toggle btn flat" (click)="showDropdown()" [ngClass]="{ 'borderColor': borderColor }">
            <span class="spancolor" *ngIf="isMultiSelect && checkedMultiList.length === 0">
                Select {{placeholder}}
            </span>
            <span class="spancolor" *ngIf="isMultiSelect && checkedMultiList.length > 0">
                {{ checkedMultiList[0] }}<ng-container *ngIf="checkedMultiList.length > 1"> +{{ checkedMultiList.length - 1 }} more</ng-container>
            </span>
            <span class="spancolor" *ngIf="!isMultiSelect && !previousSeletedValues ">
                Select {{placeholder}}
            </span>
            <span class="spancolor" *ngIf="!isMultiSelect && previousSeletedValues ">
                {{previousSeletedValues }}
            </span>
        </button>
    <div #dropdownContainer class="drop-show" *ngIf="showDropDown" (focusin)="onDropdownFocusIn()"
        (focusout)="onDropdownFocusOut()">
        <div class="drop-header">
            <div class="usersFilter__branchesField">
                <div class="usersFilter__branchWrappar">
                    <img class="usersFilter__searchIcon" src="../../../../assets/Images/user-management/searchIcon.svg"
                        alt="search" />
                    <input #dropdownInput (input)="handleFilter($event)" class="usersFilter__input" [formControl]="searchControl"
                        (keydown)="onKeyDown($event)" placeholder="Search" />
                </div>
            </div>
            <div *ngIf="showEmailIcon" class="createPackage__InviteUser" (click)="addItem(searchControl.value)">
                <img src="../../../../assets/Images/create-package/Addor.svg" alt="add" />
                Add External Email
            </div>
        </div>    
        <div class="drop-body" (scroll)="onDropdownScroll($event)">
            <div *ngIf="isMultiSelect === true">
                <label *ngFor="let item of multiListData" (mousedown)="$event.preventDefault()">
                    <app-checkbox checkboxStatus="{{item.checked}}"
                        (checked)="getMultiSelectedValue($event.event.target.checked, item)"></app-checkbox>
                    <span>{{item.name}}</span>
                </label>
            </div>
            <div *ngIf="isMultiSelect === false">
                <label (mousedown)="singleSelectedValue(item)" *ngFor="let item of multiListData; let i = index" [class.focused]="i === focusedIndex"
                    (click)="singleSelectedValue(item)">
                    {{ item.name }}
                </label>
            </div>
        </div>
    </div>
    </div>
</div>